<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>Pending items to order:</label>
					<input type="text" class="form-control" readOnly v-model="pending_items.length">
				</div>

				<div class="form-group">
					<label>Vendors for pending items:</label>
					<input type="text" class="form-control" readOnly v-model="pending_vendors.length">
				</div>

			</div>
		</div>

		<div class="row">
			<div class="col-md-6">
				<label>Choose Vendor</label>
				<multiselect placeholder="Select Vendor" label="name" v-model="vendor" :options="pending_vendors" :searchable="true" :allow-empty="true"></multiselect>
			</div>
        </div>
        <div class="row">
            <br>
			<div class="col-md-12" v-if="vendor !== null">
                <div slot="body">
                    <div>
                        <div class="row">
                            <div class="col-md-3 pr-0">
                                <input @keyup="getVendorPendingItems(1)" v-model="search" type="text" name="" class="form-control pull-left" style="width:200px;" placeholder="Search Item"> &nbsp;
                                <button @click="getVendorPendingItems(1)" class="btn btn-warning"><i class="fa fa-refresh"></i></button>
                            </div>
                            <div class="col-md-4 row pl-0">
                                <div class="col-md-4"><label>Requested TD</label></div>
                                <div class="col-md-8">
                                    <el-date-picker v-model="requested_td_filter" type="daterange" placeholder="Pick a range"></el-date-picker>
                                </div>
                            </div>
                        </div>
                        <br>
                        <el-table
                        :data="items"
                        v-loading.body="tableRequest1"
                        border
                        style="width: 100%">
                            <el-table-column
                                prop="sales_order.sales_order_number"
                                label="Sales Order No"
                                 width="250">
                            </el-table-column>
                            <el-table-column
                                prop="quotation.vendor.name"
                                label="Vendor"
                                 width="350">
                            </el-table-column>
                            <el-table-column
                                prop="quotation.item.part_number"
                                label="Part Number"
                                width="250">
                            </el-table-column>
                            <el-table-column
                                width="450"
                                label="Description">
                                <template scope="scope">
                                    {{(scope.row.price_etest_tooling || scope.row.price_setup) ? 'Tooling,setup' : scope.row.quotation.item.description}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="quantity"
                                width="150"
                                label="QTY">
                            </el-table-column>
                            <el-table-column
                                width="200"
                                prop="hq_delivery_date"
                                label="Requested TD">
                            </el-table-column>
                            <el-table-column
                                label="Direct Shipment"
                                 width="170">
                                <template scope="scope">
                                    <span v-if="scope.row.direct_shipment == 1">Yes</span>
                                    <span v-if="scope.row.direct_shipment == 0">No</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                class-name="text-center"
                                label="Operations"
                                width="180">
                                <template scope="scope">
                                    <button @click="addPurchaseItem(scope.row)" :disabled="isDisabledAdding(scope.row)" class="btn btn-primary btn-xtra-small">
                                        <i class="fa fa-plus"></i>
                                    </button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            :total="items_pagination.total"
                            layout="total, prev, pager, next, sizes"
                            :current-page="items_pagination.current_page"
                            @current-change="fetchPaginate"
                            :page-size="itemsLimit"
                            @size-change="handleSizeChange"
                            :page-sizes="[5, 10, 15, 20, 25, 30, 50]"
                            >
                        </el-pagination>
                    </div>
                </div>
			</div>
		</div>
        <div class="row">
            <div id="items-list" class="col-md-12">
                <br>
                <p>Selected Items</p>
                <el-table
                :data="purchase_order_items"
                border
                style="width: 100%">
                    <el-table-column
                        prop="sales_order.sales_order_number"
                        label="Sales Order No"
                            width="250">
                    </el-table-column>
                    <el-table-column
                        prop="quotation.vendor.name"
                        label="Vendor"
                        width="350">
                    </el-table-column>
                    <el-table-column
                        prop="quotation.item.part_number"
                        label="Part Number"
                        width="250">
                    </el-table-column>
                    <el-table-column
                        width="450"
                        prop="quotation.item.description"
                        label="Description">
                    </el-table-column>
                    <el-table-column
                        prop="quantity"
                        width="150"
                        label="QTY">
                    </el-table-column>
                    <el-table-column
                        width="200"
                        :class-name="'bg-light-blue'"
                        prop="hq_delivery_date"
                        label="Requested TD">
                    </el-table-column>
                    <el-table-column
                        label="Direct Shipment"
                         width="170">
                        <template scope="scope">
                            <span v-if="scope.row.direct_shipment == 1">Yes</span>
                            <span v-if="scope.row.direct_shipment == 0">No</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        class-name="text-center"
                        label="Operations"
                        width="180">
                        <template scope="scope">
                           <button @click="removePurchaseItem(scope.$index)" class="btn btn-danger btn-xtra-small">
                                <i class="fa fa-remove"></i>
                            </button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-right">
                <div class="pull-right">
                    <br>
                    <el-button type="primary" v-if="purchase_order_items.length && vendor !== null" :loading="submitting" @click="submitPurchaseOrder">Submit</el-button>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
    import swal from 'sweetalert2'
    import {Pagination} from 'element-ui'

	export default {
        data() {
            return {
                vendor: null,
                pending_items:[],
                pending_vendors:[],
                items:[],
                search:"",
                purchase_order_items:[],
                itemsLimit: 5,
                items_pagination:[],
                page:1,
                tableRequest1: false,
                submitting: false,
                prev_vendor:{},
                requested_td_filter: ''
            }
        },
        components: {
            Multiselect,
            'el-pagination': Pagination
        },
        computed: {
            selected_ids: function(){
                return this.purchase_order_items.map(function(a){
                    return a.id
                })
            }
        },
        created () {
            this.getPendingItems()
            this.getPendingVendors()
        },
        watch: {
            'vendor': function(val, prev){
                var self = this
                if(this.purchase_order_items.length && val != this.prev_vendor){
                    swal({
                        title: 'Are you sure?',
                        text: "There are already selected purchase order items, these will be emptied!",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes'
                    }).then(function () {
                        self.purchase_order_items = []
                    }, function(dismiss){
                        self.vendor = prev
                        self.prev_vendor = self.vendor // used to track if forced changed
                    })
                }else{
                    this.getVendorPendingItems(1)
                }
            },
            'itemsLimit': function(){
                this.getVendorPendingItems()
            },
            requested_td_filter : function() {
                this.getVendorPendingItems(1)
            }
        },
        methods: {
            getPendingItems: function(){

                var search = ''

                if(this.$root.userRole == 'purchaser'){
                  search += 'buyer_id=' + this.$root.user.id +'&';
                }

            	this.$http.get(process.env.API_ENDPOINT + '/purchase_order/pending/items?'+search+'token=' + this.$cookies.get('teltonika_session')).then((response) => {
                  	this.pending_items = response.body
                }, (response) => {
                  console.log(response)
                })
            },
            getPendingVendors: function(){
                var search = ''

                if(this.$root.userRole == 'purchaser'){
                  search += 'buyer_id=' + this.$root.user.id +'&';
                }

                this.$http.get(process.env.API_ENDPOINT + '/purchase_order/pending/vendors?'+search+'token=' + this.$cookies.get('teltonika_session')).then((response) => {
                    this.pending_vendors = response.body
                }, (response) => {
                  
                })
            },
            getVendorPendingItems: function(page = this.page, search = this.search){
                var filters = ''

                this.tableRequest1 = true

                filters += '&limit=' + this.itemsLimit
                filters += '&page=' + page
                if(search !== ''){
                    filters += '&search=' + search
                }

                filters += '&vendor_id=' + this.vendor.id

                if(this.$root.userRole == 'purchaser'){
                  filters += '&buyer_id=' + this.$root.user.id;
                }

                if(this.requested_td_filter){
                  if(this.requested_td_filter[0]){
                    filters += '&requested_td_start=' + moment(this.requested_td_filter[0]).format('YYYY-MM-DD') + '&';
                  }

                  if(this.requested_td_filter[1]){
                    filters += '&requested_td_end=' + moment(this.requested_td_filter[1]).format('YYYY-MM-DD') + '&';
                  }
                }

                this.$http.get(process.env.API_ENDPOINT + '/purchase_order/pending/items?token=' + this.$cookies.get('teltonika_session') + filters).then((response) => {
                    this.items = response.body.data
                    this.items_pagination = response.body
                    this.tableRequest1 = false
                }, (response) => {
                    
                })
            },
            addPurchaseItem: function(item){
                this.purchase_order_items.push(item)
            },
            removePurchaseItem: function(index){
                this.purchase_order_items.splice(index, 1)
            },
            isDisabledAdding: function(row){
                if(this.selected_ids.includes(row.id)){
                    return true;
                }

                return false
            },
            handleSizeChange: function(size){
                this.itemsLimit = size
            },
            fetchPaginate: function(page){
                if(this.page != page) {
                    this.page = page
                    this.getVendorPendingItems()
                }
            },
            submitPurchaseOrder: function(){
                this.submitting = true
                var formData = {
                    vendor_id: this.vendor.id,
                    items: this.purchase_order_items,
                    user_id: this.$root.user.id
                }
                this.$parent.$emit('close', true)
                this.$http.post(process.env.API_ENDPOINT + '/purchase-order/save?token=' + this.$cookies.get('teltonika_session'), formData).then((response) => {
                    if (response.status == 201) {
                        this.submitting = false
                        this.$parent.$emit('close', true)
                        var route = this.$router.resolve({path: '/purchase-order/edit/'+response.body.id})
                        window.open(route.href, '_blank')
                    }
                }, (response) => {
                    this.$notify({
                        title: 'Error',
                        message: 'Something went wrong!',
                        type: 'error',
                        duration: 3000
                    })
                    this.submitting = false
                })
            }
        }
    }
</script>

<style>
    .modal-dialog {
        max-width: 95%;
        margin: 30px auto; 
    }
    .modal-mask{
        z-index:1000 !important;
    }
    .el-pagination__total {
        font-size: 14px;
        font-weight: 800;
    }
</style>


// WEBPACK FOOTER //
// purchase-order.vue?09548784